import { fetchJson } from '../../utils/http';
import { getDiscoveryUrl } from '../../utils/environmentUtils';

export const fetchDiscoveryURLs = async () => fetchJson(getDiscoveryUrl(), {}, 1);
